module.exports = __webpack_public_path__ + "static/media/windowslogo.7b40736a.png";